// Exports
export default {
	"container": "container_ZyAjE",
	"mirror": "mirror_REHpg",
	"spinOverlay": "spinOverlay_4tM0F",
	"videoWrapper": "videoWrapper_y0dXr",
	"cameraVideo": "cameraVideo_tOAtt"
};
